export default __webpack_public_path__ + "5e895df5f6db1a31ce47bfacfcc589e1.png";